export default __webpack_public_path__ + "static/media/Thiago Gondim_.cf8080bc.png";